// Single source of truth for dev seed credentials. Lives in `src/lib/` (not
// `src/db/`) so the LoginForm can import these constants without pulling the
// postgres client into the browser bundle.

export const DEV_ARCHITECT_PASSWORD = "architect123!";
export const DEV_CONTRIBUTOR_PASSWORD = "contributor123!";
export const DEV_ADMIN_PASSWORD = "admin123!";
